import { Text, TextArea } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { noop } from '../../../lib/utils';
import styles from './SubmitReview.module.css';

const cx = classnames.bind(styles);

export default function WriteReview({
  onReviewChange,
  submitError,
}) {
  const { t } = useTranslation('review');
  return (
    <Fragment>
      <Text>
        {t('writeShortReview', { ns: 'review' })}
      </Text>
      <br />
      <br />
      <TextArea
        autoHeight
        className={cx('textarea')}
        onChange={onReviewChange}
        placeholder={t('tellUs', { ns: 'review' })}
      />
      {!!submitError && (
        <Text as="p" color="orange">
          {t('errorSubmittingReview', { ns: 'review' })}
        </Text>
      )}
    </Fragment>
  );
}

WriteReview.propTypes = {
  onReviewChange: PropTypes.func,
  submitError: PropTypes.string,
};

WriteReview.defaultProps = {
  onReviewChange: noop,
  submitError: undefined,
};
